import React, {useEffect, useState} from 'react'
import PaymentForm from '../common/PaymentForm'
import {
  useGetPaymentMethodsQuery,
  useGetPaymentSessionQuery
} from '../../services/guestPortalApi'
import LoadingSpinner, {LoadingSpinnerSize} from '../common/LoadingSpinner'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {
  faCheck,
  faCheckCircle,
  faXmarkCircle
} from '@fortawesome/free-solid-svg-icons'
import {Button} from 'react-daisyui'

enum ViewState {
  Loading = 'Loading',
  Success = 'Success',
  Error = 'Error',
  Unsubmitted = 'Unsubmitted'
}

const MemberUpdatePayment = ({reservation}: {reservation: any}) => {
  const [viewState, setViewState] = useState(ViewState.Unsubmitted)

  const paymentMethodsQuery = useGetPaymentMethodsQuery({reservation})
  const paymentSessionQuery = useGetPaymentSessionQuery({reservation})

  return (
    <div className="rows gap-4 space-y-4 max-w-[600px]">
      {paymentMethodsQuery.isLoading && (
        <div className="flex flex-row justify-center items-center pt-4 gap-2">
          <LoadingSpinner size={LoadingSpinnerSize.Large} />
        </div>
      )}

      {paymentMethodsQuery.data && viewState === ViewState.Unsubmitted && (
        <PaymentForm
          paymentMethods={paymentMethodsQuery.data}
          paymentSession={paymentSessionQuery.data}
          isSavedPayment={true}
          onPaymentCompleted={(data: any) => {
            setViewState(ViewState.Success)
          }}
          onPaymentError={(err: any) => {
            setViewState(ViewState.Error)
          }}
        ></PaymentForm>
      )}

      {viewState === ViewState.Success && (
        <div className=" flex flex-col items-center border rounded-lg p-4">
          <FontAwesomeIcon
            icon={faCheckCircle}
            className="text-green-500 text-4xl p-4"
          />
          <p className="text-center">Your payment method has been updated!</p>
        </div>
      )}

      {viewState === ViewState.Error && (
        <div className="text-red-500 flex flex-col items-center border rounded-lg p-4">
          <FontAwesomeIcon icon={faXmarkCircle} className="text-4xl p-4" />
          <p className="text-center">
            {' '}
            There was an error updating your payment method, please try again or
            reach out for assistance.
          </p>
          <Button
            onClick={() => setViewState(ViewState.Unsubmitted)}
            color="secondary"
            className="btn-sm mt-4"
          >
            try again
          </Button>
        </div>
      )}
    </div>
  )
}

export default MemberUpdatePayment
